import { RSAA } from 'redux-api-middleware';

// Constants
export const ALERTS_IS_FETCHING = 'ALERTS_IS_FETCHING';
export const ALERTS_GET_SUCCESS = 'ALERTS_GET_SUCCESS';
export const ALERTS_GET_ERROR = 'ALERTS_GET_ERROR';
export const ALERTS_GET_COUNT_SUCCESS = 'ALERTS_GET_COUNT_SUCCESS';
export const ALERTS_GET_COUNT_ERROR = 'ALERTS_GET_COUNT_ERROR';
export const ALERTS_SET_CURRENT_PAGE = 'ALERTS_SET_CURRENT_PAGE';

// Actions
export const getAlertList = queryString => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_NOTIFICATION',
      controlAction: 'collection',
      queryString,
      types: [
        ALERTS_IS_FETCHING,
        {
          type: ALERTS_GET_SUCCESS,
          meta: { ...queryString }
        },
        ALERTS_GET_ERROR
      ]
    }
  };
};

// TODO: waiting for lighter API
export const getAlertCount = () => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_NOTIFICATION',
      controlAction: 'collection',
      types: [ALERTS_IS_FETCHING, ALERTS_GET_COUNT_SUCCESS, ALERTS_GET_COUNT_ERROR]
    }
  };
};

// Initial State
export const initialState = {
  defaultSearchParams: {
    alertsPerPage: 10,
    alertsPageNumber: 1
  },
  sorting: {
    prop: 'name',
    direction: 'asc'
  },
  pagination: {
    alertsPageNumber: 1,
    total: 0
  },
  isFetching: false,
  items: [],
  unread: 0,
  selectedItem: null,
  error: null
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case ALERTS_IS_FETCHING:
      return { ...state, isFetching: true, error: null };

    case ALERTS_GET_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        items: action.payload.items,
        unread: action.payload.items.reduce((res, cur) => res + (cur.read ? 0 : 1), 0),
        pagination: {
          ...state.pagination,
          alertsPageNumber: +action.meta.alertsPageNumber,
          total: Math.ceil(action.payload.totalCount / action.payload.perPage)
        },
        sorting: {
          ...state.sorting,
          prop: action.meta && action.meta.orderBy ? action.meta.orderBy : state.sorting.prop,
          direction: action.meta && action.meta.orderDirection ? action.meta.orderDirection : state.sorting.direction
        }
      };

    case ALERTS_GET_COUNT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        unread: action.payload.items.reduce((res, cur) => res + (cur.read ? 0 : 1), 0)
      };

    case ALERTS_GET_ERROR:
    case ALERTS_GET_COUNT_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };

    case ALERTS_SET_CURRENT_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          current: Number(action.page)
        }
      };
    default:
      return state;
  }
};
